/*
 * JoinPage — public standalone lead-capture page at /join
 * =======================================================
 * Mirrors the "Δοκιμαστικά" section from AcademyLandingPage so users landing
 * here get the same messaging and form. Keeps the ?partner=<slug> referral
 * badge for partner-attribution flows.
 */
import { Handshake } from "lucide-react";
import { useSearchParams, Link } from "react-router-dom";
import PublicEnquiryForm from "../components/PublicEnquiryForm";
import SEO from "../components/SEO";

const JoinPage = () => {
  const [searchParams] = useSearchParams();
  const partnerSlug = searchParams.get("partner");

  return (
    <div className="min-h-screen bg-[#0a0a0a]" data-testid="join-page">
      <SEO
        title="Δοκιμαστικά · Λευτεριά FC"
        description="Γνώρισε από κοντά τη Λευτεριά FC Academy μέσα από μία εβδομάδα δοκιμαστικών προπονήσεων."
      />

      <section
        className="pt-32 pb-16 px-6 bg-gradient-to-b from-[#0a0a0a] to-[#050505]"
        data-testid="join-enquiry-section"
      >
        <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 items-start">
          {/* Left: same copy as AcademyLandingPage */}
          <div>
            <p className="text-[#F5A623] text-xs uppercase tracking-widest mb-2">
              Ενδιαφέρεσαι;
            </p>
            <h1
              className="font-['Bebas_Neue'] text-4xl md:text-5xl text-white tracking-tight mb-4"
              data-testid="join-heading"
            >
              Δοκιμαστικά
            </h1>
            <p className="text-zinc-400 text-sm leading-relaxed mb-4">
              Γνώρισε από κοντά τη Λευτεριά FC Academy μέσα από μία εβδομάδα
              προπονήσεων. Τα παιδιά συμμετέχουν κανονικά στις προπονήσεις,
              γνωρίζουν τους προπονητές, το προσωπικό και το περιβάλλον της
              ακαδημίας, ώστε εσείς και το παιδί σας να αποφασίσετε με σιγουριά
              αν είναι η σωστή επιλογή.
            </p>
            <p className="text-zinc-500 text-xs">
              Δεν βρίσκεις ό,τι ψάχνεις; Δες τη{" "}
              <Link
                to="/academy/registration"
                className="text-[#F5A623] hover:underline"
              >
                πλήρη σελίδα εγγραφής
              </Link>
              .
            </p>
          </div>

          {/* Right: same PublicEnquiryForm as AcademyLandingPage */}
          <div className="bg-[#0f0f0f] border border-[#262626] rounded-2xl p-5 sm:p-6">
            {partnerSlug && (
              <div
                className="mb-4 flex items-center gap-2 px-3 py-2 rounded-lg bg-[#F5A623]/10 border border-[#F5A623]/30 text-xs text-[#F5A623]"
                data-testid="partner-referral-badge"
              >
                <Handshake size={14} /> Παραπομπή μέσω συνεργάτη:{" "}
                <strong className="text-white">{partnerSlug}</strong>
              </div>
            )}
            <PublicEnquiryForm
              compact
              hideInterest
              source="website"
              partnerSlug={partnerSlug}
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default JoinPage;
